// extracted by mini-css-extract-plugin
export default {"advertDetailServiceList":"c-o_eY","advertDetailServiceList__header":"c-o_eZ","advertDetailServiceList__list":"c-o_fa"};